import { render, staticRenderFns } from "./ObjectsRealty.vue?vue&type=template&id=4353c081&"
import script from "./ObjectsRealty.vue?vue&type=script&lang=js&"
export * from "./ObjectsRealty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports